import { render, staticRenderFns } from "./NewCustomerUserModal.vue?vue&type=template&id=fa7c32b4&scoped=true"
import script from "./NewCustomerUserModal.vue?vue&type=script&lang=ts"
export * from "./NewCustomerUserModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c32b4",
  null
  
)

export default component.exports